import { Text } from '@chakra-ui/react'
import React from 'react'
import NoteListEl from './NoteListEl'

const NotesList = ({ notes }) => {
    return (
        <div className='notes-list-container'>
            {notes?.length === 0
                ? <Text>No posts yet... Feeling lonely here.</Text>
                : notes?.map(note => <NoteListEl key={note.id} note={note} />)}
        </div>
        
    )
}

export default NotesList